import { render, staticRenderFns } from "./ItemGrupo.vue?vue&type=template&id=a011b270&"
import script from "./ItemGrupo.vue?vue&type=script&lang=js&"
export * from "./ItemGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports